import { ReactComponent as TractorImage } from 'components/assets/tractor.svg';
import BasePageWithTopNav from 'components/layout/TopNavigationLayout';
import ErrorCover from 'components/widgets/Error/Cover';

const MarketNotInSubscription = () => {
  return (
    <BasePageWithTopNav>
      <ErrorCover
        errorImage={<TractorImage />}
        title="Upgrade to access this market"
        description="Your current subscription doesn’t include this market. Our sales team will be happy to help to upgrade to access to additional markets."
      />
    </BasePageWithTopNav>
  );
};

export default MarketNotInSubscription;
